export enum AuditCompanyInformationFormPlaceholdersEnum {
  CUSTOMER_MAD_CODE = 'KOHLR001900',
}
